import Icon from "@mui/icons-material/Tag";

export default function ImplementorsIcon(props) {
	return <Icon color={props.color} fontSize={props.fontSize || "medium"} />;
}
